import { Nullable } from 'global';
import {
  FinanceFilters,
  FinanceFilterType,
  FinanceApiFilterType,
  FinanceFiltersPayload,
  FinanceFiltersPayloadItem,
} from './types';

const getPayloadFilter = (key: FinanceFilterType, v: any): Nullable<FinanceFiltersPayloadItem[]> => {
  switch (key) {
    case FinanceFilterType.DEAL_DATE: {
      const value = v as FinanceFilters[FinanceFilterType.DEAL_DATE];
      return [
        {
          key: FinanceApiFilterType.DEAL_DATE,
          value: {
            from: value.from.toISOString(),
            to: value.to.toISOString(),
          },
        },
      ];
    }
    case FinanceFilterType.SALES_REP: {
      const typedValue = v as FinanceFilters[FinanceFilterType.SALES_REP];
      const value = typedValue.map(v => (v.value === 'unassigned' ? null : v.value));
      if (!value.length) return null;
      return [
        {
          key: FinanceApiFilterType.SALES_REP,
          value,
        },
      ];
    }
    case FinanceFilterType.LOCATION: {
      const typedValue = v as FinanceFilters[FinanceFilterType.LOCATION];
      const value = typedValue.map(v => (v.value === 'unassigned' ? null : v.value));
      if (!value.length) return null;
      return [
        {
          key: FinanceApiFilterType.LOCATION,
          value,
        },
      ];
    }
    default:
      return null;
  }
};

export const formatFilterForFinancePayload = (filters: Nullable<Partial<FinanceFilters>>): FinanceFiltersPayload => {
  if (!filters) return [];

  return Object.entries(filters).reduce<FinanceFiltersPayload>((result, [key, value]) => {
    const payloadFilter = getPayloadFilter(key as FinanceFilterType, value);
    if (payloadFilter) {
      return [...result, ...payloadFilter];
    }
    return result;
  }, []);
};

export const calcFinanceFiltersAmount = (filters: Nullable<Partial<FinanceFilters>>) => {
  if (!filters) return 0;

  return Object.entries(filters).reduce<number>((amount, [key, value]) => {
    if (key === FinanceFilterType.DEAL_DATE) return amount;

    if (Array.isArray(value)) return (amount += value.length);

    if (typeof value == 'object') {
      return (amount += Object.values(value).filter(Boolean).length);
    }

    if (typeof value == 'boolean' && value) {
      return (amount += 1);
    }

    return amount;
  }, 0);
};
